import Login from '../pages/Login'
import Visits from '../pages/Visits'
import Plans from '../pages/Plans'
import Customers from '../pages/Customers'
import Products from '../pages/Products'
import Profile from '../pages/Profile'
import VisitsFrequency from '../pages/VisitsFrequency'
import SpecialtyVisitMaterials from '../pages/SpecialtyVisitMaterials'
import Exams from '../pages/Exams'
import Notifications from '../pages/Notifications'
import ItemPlan from '../pages/ItemPlan'
import VisitInvoicePreview from '../pages/VisitInvoicePreview'
import MaterialsJournal from '../pages/MaterialsJournal'
import ItemPlanExcel from '../pages/ItemPlanExcel'
import AddVisitDetails from '../pages/AddVisitDetails'
import AddVisitPayment from '../pages/AddVisitPayment'
import RegionPlansStatistics from '../pages/RegionPlansStatistics'
import Expenses from '../pages/Expenses'

export default [
	{
		path: '/',
		name: 'visits',
		meta: { i18nTranslateKey: 'visits' },
		component: Visits
	},
	{
		path: '/plans',
		name: 'plans',
		meta: { i18nTranslateKey: 'plans' },
		component: Plans
	},
	{
		path: '/login',
		name: 'login',
		meta: { i18nTranslateKey: 'login' },
		component: Login
	},
	{
		path: '/customers',
		name: 'customers',
		meta: { i18nTranslateKey: 'customers' },
		component: Customers
	},
	{
		path: '/products',
		name: 'products',
		meta: { i18nTranslateKey: 'products' },
		component: Products
	},
	{
		path: '/profile',
		name: 'profile',
		meta: { i18nTranslateKey: 'profile' },
		component: Profile
	},
	{
		path: '/visits-frequency',
		name: 'visits-frequency',
		meta: { i18nTranslateKey: 'visits-frequency' },
		component: VisitsFrequency
	},
	{
		path: '/specialty-visit-materials',
		name: 'specialty-visit-materials',
		meta: { i18nTranslateKey: 'specialty-visit-materials' },
		component: SpecialtyVisitMaterials
	},
	{
		path: '/exams',
		name: 'exams',
		meta: { i18nTranslateKey: 'exams' },
		component: Exams
	},
	{
		path: '/notifications',
		name: 'notifications',
		meta: { i18nTranslateKey: 'notifications' },
		component: Notifications
	},
	{
		path: '/item-plan',
		name: 'item-plan',
		meta: { i18nTranslateKey: 'item-plan' },
		component: ItemPlan
	},
	{
		path: '/item-plan-excel',
		name: 'item-plan-excel',
		meta: { i18nTranslateKey: 'item-plan' },
		component: ItemPlanExcel

	},
	{
		path: '/visits/:visitId/invoice-preview',
		name: 'visit-invoice-preview',
		meta: { i18nTranslateKey: 'invoice-preview' },
		component: VisitInvoicePreview
	},
	{
		path: '/materials-journal',
		name: 'materials-journal',
		meta: { i18nTranslateKey: 'materials-journal' },
		component: MaterialsJournal
	},
	{
		path: '/visits/add/details',
		name: 'add-visit-details',
		meta: { i18nTranslateKey: 'add-visit-details', hideChrome: true },
		component: AddVisitDetails
	},
	{
		path: '/visits/add/payment',
		name: 'add-visit-payment',
		meta: { i18nTranslateKey: 'add-visit-payment', hideChrome: true },
		component: AddVisitPayment
	},
	{
		path: '/region-plans-statistics',
		name: 'region-plans-statistics',
		meta: { i18nTranslateKey: 'region-plans-statistics', hideChrome: true },
		component: RegionPlansStatistics
	},
	{
		path: '/expenses',
		name: 'expenses',
		meta: { i18nTranslateKey: 'expenses' },
		component: Expenses
	},
]
